import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b964083"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { style: {"background":"white","border-radius":"9px","padding":"20px 10px 10px","width":"355px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "推荐人地址")
], -1))
const _hoisted_4 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_7 = { class: "home-header" }
const _hoisted_8 = { class: "home-header-title" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "TRX永续存款合约", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 存款规则 ")
const _hoisted_12 = { class: "home-header-card" }
const _hoisted_13 = { class: "home-header-card-top" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("我的存款: ")
const _hoisted_15 = { style: {"color":"#ffed22","font-weight":"bold"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" TRX")
const _hoisted_17 = { style: {"background":"rgba(32,86,145,.21)","margin":"0"} }
const _hoisted_18 = { style: {"color":"#ffed22","font-weight":"bold","padding-right":"8px"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("人")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "合约余额", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "TRX", -1))
const _hoisted_22 = { class: "home-header-card-bottom" }
const _hoisted_23 = { class: "home-content" }
const _hoisted_24 = { class: "home-content-title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "存入合约", -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("计时器:")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { innerHTML: '\u2003' }, null, -1))
const _hoisted_28 = { class: "home-content-action" }
const _hoisted_29 = { class: "home-content-balance" }
const _hoisted_30 = { class: "home-content-userInfo" }
const _hoisted_31 = { class: "home-content-actionDetails" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RuleDialog = _resolveComponent("RuleDialog")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.ruleDialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleDialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.ruleDialogVisible)
          ? (_openBlock(), _createBlock(_component_RuleDialog, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.promoteDialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.promoteDialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_q_input, {
            borderless: "",
            placeholder: '请输入推荐人地址',
            modelValue: _ctx.inputRefAddress,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputRefAddress) = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.showRefAddressTip)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.refTip), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_q_btn, {
              style: {"width":"48.2%","margin-right":"3.6%"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.promoteDialogVisible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              style: {"width":"48.2%","background":"#1677ff","color":"white"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleInputRefAddress()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createElementVNode("img", { src: _ctx.iconImg }, null, 8, _hoisted_9),
          _hoisted_10
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_q_btn, {
            style: {"width":"90px","height":"30px","min-height":"30px"},
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDialog())),
            outline: ""
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", null, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.myDepositAmount.toString()), 1),
            _hoisted_16
          ]),
          _createElementVNode("p", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.totalUser.toString()), 1),
            _hoisted_19
          ])
        ]),
        _hoisted_20,
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.marketTotalDepositAmount.toFixed(2)), 1),
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", null, "累计存款: " + _toDisplayString(_ctx.accumulatedDeposit.toString()), 1),
          _createElementVNode("span", null, "累计取款: " + _toDisplayString(_ctx.cumulativeWithdrawal.toString()), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("span", null, [
          _hoisted_26,
          _hoisted_27,
          _createTextVNode(" " + _toDisplayString(_ctx.leftTime.day) + "天" + _toDisplayString(_ctx.leftTime.hour) + "时" + _toDisplayString(_ctx.leftTime.minutes) + "分" + _toDisplayString(_ctx.leftTime.seconds) + "秒", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_q_input, {
          type: "number",
          borderless: "",
          placeholder: '请输入存入合约金额',
          modelValue: _ctx.supplyAmount,
          "onUpdate:modelValue": [
            _cache[6] || (_cache[6] = ($event: any) => ((_ctx.supplyAmount) = $event)),
            _ctx.supplyAmountInput
          ],
          style: {"width":"100%!important","border":"unset","font-size":"20px","height":"40px","background":"rgb(240, 243, 248)"}
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_q_btn, {
          class: _normalizeClass([_ctx.expandBtn?'expand':'', "home-content-action-btn"]),
          style: _normalizeStyle(_ctx.depositBtnEnable?'':' background: #999999!important;'),
          disable: !_ctx.depositBtnEnable,
          onClick: _ctx.deposit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.inputTip), 1)
          ]),
          _: 1
        }, 8, ["class", "style", "disable", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_29, "我的余额: " + _toDisplayString(_ctx.myTRXBalance.toString()) + " TRX", 1),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("span", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tabIndex = 0)),
          class: _normalizeClass(_ctx.tabIndex===0?'active':'')
        }, "存款记录", 2),
        _createElementVNode("span", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.tabIndex = 1)),
          class: _normalizeClass(_ctx.tabIndex===1?'active':'')
        }, "取款记录", 2)
      ]),
      _createElementVNode("div", _hoisted_31, [
        (_ctx.tabIndex===0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDepositInfo, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "home-content-actionDetails-item",
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.time), 1),
                  _createElementVNode("span", null, "+ " + _toDisplayString(item.amount.toString()) + " TRX", 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tabIndex===1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userWithdrawInfo, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "home-content-actionDetails-item",
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.time), 1),
                  _createElementVNode("span", null, "- " + _toDisplayString(item.amount.toString()) + " TRX", 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}